import { TextSmall } from '@/components/Texts';
import React from 'react';

const DataDeletionStorage = () => {
  return (
    <>
      <TextSmall fontWeight={700}>
        (5) Data deletion and storage period, duration of data processing
      </TextSmall>
      <TextSmall>
        For the processing operations carried out by us, we indicate below in
        each case how long the data will be stored by us and when it will be
        deleted or blocked. Unless an explicit storage period is specified
        below, your personal data will be deleted or blocked as soon as the
        purpose or legal basis for the storage no longer applies. In principle,
        your data will only be stored on our servers in Europe, subject to any
        transfer that may take place in accordance with the provisions in A.(7)
        and A.(8).
      </TextSmall>
      <TextSmall>
        The requests by contact form are deleted if they are no longer required.
        We review the necessity every six months; the statutory archiving
        obligations also apply.
      </TextSmall>
      <TextSmall>
        {`We retain all data necessary for contract fulfillment for a period of
        three years, at least for a year, starting from your termination of our
        services. In particular, financial information is subject to regulatory
        requirements, mandating us to retain the data for up to 10 years,
        depending on the customer's location. The retention period for financial
        information is contingent upon the regulations of the country in which
        you reside.`}
      </TextSmall>
      <TextSmall>
        However, storage may take place beyond the specified time in the event
        of a (threatened) legal dispute with you or other legal proceedings or
        if storage is provided for by legal regulations to which we are subject
        as the responsible party. If the storage period prescribed by the legal
        regulations expires, the personal data will be blocked or deleted unless
        further storage by us is necessary and there is a legal basis for this.
      </TextSmall>
      <TextSmall>
        Your data will only be processed for as long as is necessary to achieve
        the mentioned processing purposes; the legal bases specified in the
        context of the processing purposes apply accordingly.
      </TextSmall>
      <TextSmall>
        Third parties engaged by us will store your data on their systems for as
        long as is necessary in connection with the provision of services for us
        in accordance with the respective order.
      </TextSmall>
    </>
  );
};

export default DataDeletionStorage;
